import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
// HashRouter was replaced by BrowserRouter for SEO: crawlers ignore everything
// after "#", so every page looked like one URL. Path URLs need the server to
// serve index.html for every route - see public/.htaccess (GoDaddy cPanel).
// Inside Capacitor the webview serves from capacitor://localhost (iOS) and
// https://localhost (Android), both of which support the history API, so
// BrowserRouter is correct there too.
import { ToastContainer } from "react-toastify";
import { HelmetProvider } from "react-helmet-async";
import { ErrorBoundary } from "react-error-boundary";
import CustomHead from "./Components/common/CustomHead";
import HashRedirect from "./Components/common/HashRedirect";
// Generated by scripts/select-router.js: re-exports Routers or MobileRouters.
import AppRouter from "./activeRouter";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "react-toastify/dist/ReactToastify.css";
import "./Styles/style.css";
import "./Styles/resume-writer-draft.css";
import "./Styles/amitCard.css";
import constant from "./utils/constant";
import { clarity } from "react-microsoft-clarity";

// Which app is this build? Set by `yarn build:mobile` / `yarn start:mobile`.
// Used below only for web-only chrome; the ROUTE TREE is swapped by the
// generated ./activeRouter module, not by a branch here - see
// scripts/select-router.js for why a ternary over two require()s is not enough
// to keep the admin routes out of the app binary.
const IS_MOBILE_BUILD = process.env.REACT_APP_TARGET === "mobile";

// Clarity records sessions. In a native app that turns into a privacy-label
// disclosure and an ATT conversation for no benefit, so it stays on web only.
if (process.env.NODE_ENV === "production" && !IS_MOBILE_BUILD) {
  clarity.init("nsg6uadw7m");
}

const { TOAST_CONTAINER_CONFIG } = constant;

function fallbackRender({ error, resetErrorBoundary }) {
  // The message alone ("t.split is not a function") says nothing about where.
  // The stack is what makes the next report actionable.
  // eslint-disable-next-line no-console
  console.error("Unhandled render error", error, error?.stack);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "150px",
      }}
      role="alert"
    >
      <div>
        <p>Something went wrong:</p>
        <pre style={{ color: "red" }}>{error.message}</pre>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            if (typeof resetErrorBoundary === "function") resetErrorBoundary();
            window.location.reload();
          }}
        >
          Reload
        </button>
      </div>
    </div>
  );
}

const App = () => {
  return (
    <>
      <ErrorBoundary fallbackRender={fallbackRender}>
        <HelmetProvider>
          <ToastContainer {...TOAST_CONTAINER_CONFIG} />
          {/* SEO head tags and legacy "/#/route" forwarding are web-only. */}
          {!IS_MOBILE_BUILD && <CustomHead />}
          <Router>
            {!IS_MOBILE_BUILD && <HashRedirect />}
            <AppRouter />
          </Router>
        </HelmetProvider>
      </ErrorBoundary>
    </>
  );
};

export default App;
